export default "/images/vendor/@coreui/icons/svg/flag/cif-sc.svg?b745cad98537f8ed4eee8524ee0d0d97";